// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__DJ1tJ","signatureBlock":"Footer_signatureBlock__2nS-P","signature":"Footer_signature__3SMdH"};